//
//
//
//
//
//
//
//
//

  export default {

    data() {
        return {
           title:""
        }
    },
    created(){
        this.typeId=this.$route.query.typeId
        this.title=this.$route.query.typeName
        // if(this.typeId==1){
        //   this.title="mes行业资讯"
        // }else if(this.typeId==2){
        //   this.title="MC核心智造平台"
        // }else if(this.typeId==3){
        //   this.title="工业APP"
        // }
    },
     methods: {
       back(){
         this.$router.go(-1)
       }
     }
}



// WEBPACK FOOTER //
// ./src/components/headTop.vue